import React, { useEffect, useState } from "react";
import {
  Users,
  AlertCircle,
  TrendingDown,
  TrendingUp,
  Clock,
  DollarSign,
  Briefcase,
  CreditCard,
  FileText,
  BookOpen,
  LogOut,
} from "react-feather";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  LineChart,
  Line,
} from "recharts";
import "../../style/css/dashboard.css";
import ImageWithBasePath from "../../core/img/imagewithbasebath";
import CountUp from "react-countup";
import { useGetDashboardDetailsQuery } from "AppQuries/dashboard/dashboard-details";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import {
  addDays,
  endOfMonth,
  endOfWeek,
  format,
  startOfMonth,
  startOfWeek,
  subDays,
} from "date-fns";
import AttendanceMAP from "./components/AttendanceMAP";
import { DatePicker } from "antd";
import Select from "react-select";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;
const filterTypeOptions = [
  {
    label: "Today",
    value: "Today",
  },
  {
    label: "Yesterday",
    value: "Yesterday",
  },
  // {
  //   label: "Week",
  //   value: "Week",
  // },
  // {
  //   label: "Month",
  //   value: "Month",
  // },
  {
    label: "Custom",
    value: "Custom",
  },
];

const getDashboardURL = (type, filters = {}) => {
  switch (type) {
    case "Claims Pending":
      return `${all_routes.claim}${all_routes?.claim_list}?status=0&fromDate=${format(new Date(filters?.fromDate), "yyyy-MM-dd")}&toDate=${format(new Date(filters?.toDate), "yyyy-MM-dd")}`;
    case "Leaves Pending":
      return `${all_routes.leave}${all_routes?.leave_manangement}?status=0&fromDate=${format(new Date(filters?.fromDate), "yyyy-MM-dd")}&toDate=${format(new Date(filters?.toDate), "yyyy-MM-dd")}`;
    case "Employees On Break":
      return `${all_routes?.attendance_listing}?status=${filters?.status}&fromDate=${format(new Date(filters?.fromDate), "yyyy-MM-dd")}&toDate=${format(new Date(filters?.toDate), "yyyy-MM-dd")}`;
    case "Absent > 3 Days":
      return `${all_routes?.attendance_listing}?status=${filters?.status}&fromDate=${format(new Date(filters?.fromDate), "yyyy-MM-dd")}&toDate=${format(new Date(filters?.toDate), "yyyy-MM-dd")}`;
    default:
      return "#";
  }
};
/* ---------------- COMPONENT ---------------- */

const NewDashboard = () => {
  const userData = useSelector(loggedInUser);
  const [isMount, setIsMount] = useState(false);
  const [selectedFilterType, setSelectedFilterType] = useState("Today");
  const [attendanceFilterDate, setAttendanceFilterDate] = useState({
    fromDate: format(new Date(), "yyyy-MM-dd"),
    toDate: format(new Date(), "yyyy-MM-dd"),
  });

  const {
    data,
    isLoading,
    isError,
    error,
    refetch: getDashboardData,
  } = useGetDashboardDetailsQuery(
    {
      companyCode: userData?.companyCode,
      isAllCompanies: userData?.isAllCompanies,
      selectedCompanyCode: userData?.selectedCompanyCode,
      userId: userData?.userID,
      locationCode: userData?.selectedLocationCode,
      ...attendanceFilterDate,
    },
    {
      enabled: !!userData?.companyCode,
    },
  );

  const {
    attendanceCount = [],
    attendanceChart = [],
    employeeMovement = [],
    dashBoardPayroll = [],
    claimAging = [],
    leaveBalanceCount = [],
    engagementSignals = [],
    teamAttendancePercentage = [],
    probationEndList = [],
    complianceStatus = [],
    attentionRequired = [],
  } = data || {};

  const getEmpMovementColor = (status) => {
    switch (status) {
      case 1:
        return { background: "linear-gradient(to left, #f4c4f3, #fc67fa)" };
      case 2:
        return { background: "linear-gradient(to left, #6190e8, #a7bfe8)" };
      case 3:
        return { background: "linear-gradient(to left, #56ab2f, #a8e063)" };
      case 4:
        return { background: "linear-gradient(to left, #4ac29a, #bdfff3)" };
      case 5:
        return { background: "linear-gradient(to left, #ffafbd, #ffc3a0)" };
      case 6:
        return { background: "linear-gradient(to left, #56ab2f, #a8e063)" };
      default:
        return { background: "linear-gradient(to left, #f2994a, #f2c94c)" };
    }
  };

  const getEmpMovementIcon = (status) => {
    switch (status) {
      case 1:
        return <TrendingUp />;
      case 2:
        return <LogOut />;
      case 3:
        return <Briefcase />;
      case 4:
        return <CreditCard />;
      case 5:
        return <FileText />;
      case 6:
        return <BookOpen />;
      default:
        return "";
    }
  };

  const attendanceFilterHandler = (e) => {
    setSelectedFilterType(e.value || "Today");

    const currentDate = format(new Date(), "yyyy-MM-dd");
    const yesterday = format(subDays(new Date(), 1), "yyyy-MM-dd");

    switch (e.value) {
      case "Today":
        setAttendanceFilterDate({
          fromDate: currentDate,
          toDate: currentDate,
        });
        break;
      case "Yesterday":
        setAttendanceFilterDate({
          fromDate: yesterday,
          toDate: yesterday,
        });
        break;
      case "Week":
        // 1 day added for date start with monday
        setAttendanceFilterDate({
          fromDate: format(addDays(startOfWeek(currentDate), 1), "yyyy-MM-dd"),
          toDate: format(addDays(endOfWeek(currentDate), 1), "yyyy-MM-dd"),
        });
        break;
      case "Month":
        setAttendanceFilterDate({
          fromDate: format(startOfMonth(currentDate), "yyyy-MM-dd"),
          toDate: format(endOfMonth(currentDate), "yyyy-MM-dd"),
        });
        break;
      case "Custom":
        break;
      default:
        setAttendanceFilterDate({
          fromDate: format(new Date(), "yyyy-MM-dd"),
          toDate: format(new Date(), "yyyy-MM-dd"),
        });
        break;
    }
  };

  useEffect(() => {
    // Refetch dashboard data when attendance filter changes
    if (isMount) {
      getDashboardData();
    }
    setIsMount(true);
  }, [attendanceFilterDate]);

  if (isLoading) <LoadingSpinner />;

  if (isError) {
    return (
      <div className="page-wrapper">
        <div className="content">
          <div className="alert alert-danger">
            Error loading dashboard: {error?.message || "Unknown error"}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-wrapper">
      <div className="content hr-dashboard ">
        <div
          className="page-header mb-2"
          style={{ background: "none", borderBottom: "none" }}
        >
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>HR Overview</h4>
              {/* <h6>Manage your employees attendance</h6> */}
            </div>
          </div>
          <div className="page-btn">
            <Select
              options={filterTypeOptions}
              placeholder="Select Filter Type"
              className={`select`}
              value={filterTypeOptions.find(
                (option) => option.value === selectedFilterType,
              )}
              onChange={attendanceFilterHandler}
              menuPortalTarget={document.body}
              styles={{
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  width: "200px",
                }),
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />
          </div>
          {selectedFilterType === "Custom" && (
            <div className="page-btn">
              <RangePicker
                // disabledDate={disabled7DaysDate}
                className="form-control"
                style={{ display: "flex" }}
                onChange={(date, dateFormat) => {
                  setAttendanceFilterDate({
                    fromDate: dateFormat[0] || format(new Date(), "yyyy-MM-dd"),
                    toDate: dateFormat[1] || format(new Date(), "yyyy-MM-dd"),
                  });
                }}
                defaultValue={[
                  dayjs(attendanceFilterDate.fromDate, "YYYY-MM-DD"),
                  dayjs(attendanceFilterDate.toDate, "YYYY-MM-DD"),
                ]}
                // format="DD-MM-YYYY"
              />
            </div>
          )}
        </div>
        {/* <div className="content hr-dashboard"> */}
        {/* <h4 className="hr-title">HR Overview</h4> */}

        {/* KPI STRIP */}
        <div className="row">
          {attendanceCount.map((item, index) => (
            <div className="col-xl-3 col-sm-6 col-12 d-flex" key={index}>
              <Link
                to={
                  item.key === "totalEmployeeCount"
                    ? all_routes.employee + all_routes.employee_list
                    : item.key === "todayPresent"
                      ? all_routes.attendance +
                        all_routes.attendance_filter +
                        "?status=Present"
                      : item.key === "appliedLeave"
                        ? all_routes.leave + all_routes.leave_manangement
                        : item.key === "unAppliedLeave"
                          ? all_routes.leave + all_routes.un_applied_leave
                          : "#"
                }
              >
                <div
                  className={`dash-widget ${
                    item.key === "totalEmployeeCount"
                      ? "dash1"
                      : item.key === "todayPresent"
                        ? "dash2"
                        : item.key === "appliedLeave"
                          ? "dash3"
                          : item.key === "unAppliedLeave"
                            ? "dash4"
                            : ""
                  } dash1 w-100`}
                >
                  <div className="dash-widgetimg">
                    <span>
                      <ImageWithBasePath
                        src={`assets/img/icons/employees.png`}
                        alt="img"
                      />
                    </span>
                  </div>
                  <div className="dash-widgetcontent">
                    <h5>{item.count}</h5>
                    <h6>{item.label}</h6>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>

        {/* ALERTS */}
        <div className="section">
          <h5>Attention Required</h5>
          <div className="alert-grid">
            {attentionRequired.map((a, i) => (
              <div key={i} className="alert-soft">
                <AlertCircle />
                <Link
                  to={getDashboardURL(a?.label, {
                    fromDate: a?.fromDate,
                    toDate: a?.toDate,
                    status: a?.status,
                  })}
                >
                  <div>
                    <h4>{a.value}</h4>
                    <p>{a.label}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>

        <div className="section">
          <h5>Attendance Map (Today)</h5>
          <div className="map-container">
            <AttendanceMAP empAttendanceList={data?.empAttendanceList} />
          </div>
        </div>

        {/* ATTENDANCE + PAYROLL */}
        <div className="row">
          <div className="col-md-7">
            <div className="card-box">
              <h5>Attendance Trend (This Week)</h5>
              <ResponsiveContainer width="100%" height={280}>
                <LineChart data={attendanceChart || []}>
                  <XAxis dataKey="dayName" />
                  <YAxis />
                  <Tooltip />
                  <Line
                    type="monotone"
                    dataKey="presentCount"
                    name="Present"
                    stroke="#4f46e5"
                    strokeWidth={3}
                  />
                </LineChart>
              </ResponsiveContainer>
            </div>
          </div>
          <div className="col-md-5">
            <div className="card-box">
              <h5>Employee Movement (This Month)</h5>
              <div className="movement-grid">
                {employeeMovement?.length > 0 &&
                  employeeMovement?.map((emp, index) => (
                    <Link
                      to={`${all_routes.employee_movements}?status=${emp?.status}`}
                      className="movement-card"
                      style={getEmpMovementColor(emp?.status)}
                      key={emp?.status}
                    >
                      <span className="movement-icon">
                        {getEmpMovementIcon(emp?.status)}
                      </span>
                      <h3>{emp?.value || 0}</h3>
                      <p style={{ color: "#002299" }}>{emp?.label}</p>
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* LEAVE + CLAIMS */}
        <div className="row">
          <div className="col-md-6">
            <div className="card-box">
              <h5>Payroll Status</h5>
              <ResponsiveContainer width="100%" height={260}>
                <PieChart>
                  <Pie
                    data={dashBoardPayroll || []}
                    dataKey="amount"
                    innerRadius={65}
                    outerRadius={90}
                  >
                    {dashBoardPayroll?.map((_, i) => (
                      <Cell key={i} fill={_.colorCode} />
                    ))}
                  </Pie>
                  <Tooltip />
                </PieChart>
              </ResponsiveContainer>
              <div className="mini-metrics">
                {dashBoardPayroll?.map(
                  ({ name, amount, status, colorCode }) => (
                    <div
                      key={name}
                      className={` mt-4`}
                      style={{ borderColor: colorCode }}
                    >
                      <span className="fw-semibold">{name} : </span>
                      <span className="fs-5 fw-bold">${amount}</span>
                    </div>
                  ),
                )}
                {/* <span>
                  <DollarSign /> Avg Salary: <b>$2,100</b>
                </span>
                <span>
                  <Clock /> Payroll Delay: <b>0 Days</b>
                </span> */}
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="card-box">
              <h5>Claims Aging</h5>
              <ResponsiveContainer width="100%" height={220}>
                <BarChart data={claimAging}>
                  <XAxis dataKey="label" />
                  <YAxis />
                  <Tooltip />
                  <Bar dataKey="value" fill="#8b5cf6" radius={[6, 6, 0, 0]} />
                </BarChart>
              </ResponsiveContainer>
            </div>
          </div>
        </div>

        {/* MOVEMENT + ENGAGEMENT */}
        <div className="row">
          <div className="col-md-6">
            <div className="card-box">
              <h5>Leave Risk</h5>
              {leaveBalanceCount?.map((l, i) => (
                <div key={i} className="list-row">
                  <span>{l.label}</span>
                  <b>{l.value}</b>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card-box">
              <h5>Engagement Signals</h5>
              {engagementSignals?.map((e, i) => (
                <div className="list-row" key={i}>
                  <span>{e?.label}</span>
                  <b>{e?.value}</b>
                </div>
              ))}
            </div>
          </div>
        </div>
        {/* HR EVENTS + PROBATION */}
        <div className="row">
          <div className="col-md-6">
            <div className="card-box">
              <h5>Team Attendance Health</h5>
              {teamAttendancePercentage?.map((t, i) => (
                <div key={i} className="list-row">
                  <span>{t.departmentName}</span>
                  <b>{t.attendancePercentage}%</b>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card-box">
              <h5>Probation / Confirmation</h5>
              {probationEndList.map((p, i) => (
                <div key={i} className="list-row">
                  <span>{p.employeeName}</span>
                  <b>{p.daysRemaining} days</b>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* COMPLIANCE + TEAM HEALTH */}
        {/* <div className="row">

          
          <div className="col-md-6">
            <div className="card-box">
              <h5>Upcoming HR Events</h5>
              {hrEvents.map((e, i) => (
                <div key={i} className="list-row">
                  <span>{e.title}</span>
                  <b>{e.date}</b>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card-box">
              <h5>Compliance Status</h5>
              {compliance.map((c, i) => (
                <div key={i} className="list-row">
                  <span>{c.label}</span>
                  <b className={c.value > 2 ? "danger-text" : ""}>{c.value}</b>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <div className="card-box">
              <h5>Team Attendance Health</h5>
              {teamAttendancePercentage?.map((t, i) => (
                <div key={i} className="list-row">
                  <span>{t.departmentName}</span>
                  <b>{t.attendancePercentage}%</b>
                </div>
              ))}
            </div>
          </div>
        </div> */}

        {/* QUICK ACTIONS */}
        <div className="card-box">
          <h5>Quick HR Actions</h5>
          <div className="quick-actions">
            <Link to={`${all_routes.employee}${all_routes.employee_list}`}>
              Employee Management
            </Link>
            <Link to={`${all_routes.leave}${all_routes.leave_manangement}`}>
              Leave Management
            </Link>
            <Link to={`${all_routes.payroll}${all_routes.payroll_stage}`}>
              Process Payroll
            </Link>
            <Link to={`${all_routes.claim}${all_routes.claim_list}`}>
              View Claims
            </Link>
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
};

export default NewDashboard;
